<template>



    <div class="d-flex flex-row flex-wrap ga-2">
        <button :class="[tile.selected ? '  button--primary' : 'button--secondary-bordered']"
            class="d-flex button--bordered" v-for="(tile, index) in offerStore.categories" :key="index"
            @click="offerStore.selectCategory(tile.id)">


            {{ tile.title }}


        </button>
    </div>



</template>








<script setup>

import { OfferStore } from '@/store/offerStore';
const offerStore = OfferStore();

</script>